// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2vGa6","icon":"index_icon_eUiom","setIcon":"index_setIcon_2V-Bd","setIconActive":"index_setIconActive_Y6Zk6","link":"index_link_g1mLP"};